import { cn } from "@/utils/cn";

import styles from "./loader.module.scss";

interface LoaderProps {
  overlay?: boolean;
}

const Loader = ({ overlay = false }: LoaderProps) => {
  return (
    <div className={cn(styles.loader, overlay && styles.overlay)}>
      <div className={styles.spinner}></div>
    </div>
  );
};

export default Loader;
